import { TableCell, TableRow, Theme, Typography } from "@mui/material";
import { TableHeaderData } from "../investorOverview/types";
import { formatCurrency } from "../../utils/utilityFunctions";
import IconCustomeDropDown from "../../lib/formik/IconsCustomeDropDown";


export const viewFamilyTableHeader: TableHeaderData[] = [
    {
        id: "familyCode",
        label: "FAMILY CODE",
        align: "left",
        isSortable: false,
    },
    {
        id: "familyName",
        label: "FAMILY NAME",
        align: "left",
        isSortable: false,
    },
    {
        id: "familyHead",
        label: "FAMILY HEAD",
        align: "left",
        isSortable: false,
    },
    {
        id: "aum",
        label: "AUM",
        align: "center",
        isSortable: false,
    },
    {
        id: "numberOfMembers",
        label: "NO. OF MEMBERS",
        align: "center",
        isSortable: false,
    },
    {
        id: "actions",
        label: "ACTIONS",
        align: "center",
        isSortable: false,
    }
]

export default function ViewFamilyTableBody({ data }: {
    data: any;
}): JSX.Element {
    return (
        <>
            {data?.map((obj: any) => {
                return (
                    <TableRow
                        key= {`${obj?.familyName}-${obj?.id}`}
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.familyID ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.familyName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.familyHeadName ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {formatCurrency({ value: obj?.aum ?? 0, locale: "en-IN", currencyCode: "INR" })}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.membersCount ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <IconCustomeDropDown 
                                  data={obj}
                                 filterValue={2} 
                                 isToggle={true}
                                 isFamily={true}
                             />
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}


